<template>
  <v-container>
    <validation-observer ref="form">
      <v-row>
        <v-col cols="12" lg="2">
          <v-select
            :label="$t('Entity')"
            :items="entities"
            item-text="name"
            item-value="id"
            v-model="entityId"
            @change="$store.dispatch('customizations/fetch')"
          ></v-select>
        </v-col>
        <v-col cols="6" lg="2" class="d-flex justify-center align-center">
          <v-menu :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <div class="v-color-picker__color mr-2" v-on="on">
                <div
                  :style="`background: ${
                    primaryColor
                      ? primaryColor.hexa
                        ? primaryColor.hexa
                        : primaryColor
                      : ''
                  } none repeat scroll 0% 0%`"
                ></div>
              </div>
              <div class="text-title">{{ $t("Primary color") }}</div>
            </template>
            <v-color-picker
              v-model="primaryColor"
              hide-mode-switch
              show-swatches
              mode="hexa"
            ></v-color-picker>
          </v-menu>
        </v-col>
        <v-col cols="6" lg="2">
          <v-switch
            :label="$t('Dark theme')"
            v-model="editedItem.dark_theme"
          ></v-switch>
        </v-col>
        <v-col cols="6" lg="2">
          <validation-provider
            v-slot="{ validate, errors }"
            name="logo"
            rules="image|size:512"
          >
            <v-file-input
              :label="$t('Logo')"
              name="image"
              v-model="image"
              prepend-icon="mdi-file-image"
              show-size
              accept="image/*"
              :hint="$t('max 512kB')"
              persistent-hint
              :error-messages="errors"
              @change="validate"
            ></v-file-input>
          </validation-provider>
        </v-col>
        <v-col cols="6" lg="2" class="d-flex justify-start align-center">
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="infos"
            mode="lazy"
          >
            <input type="hidden" v-model="infos" />
            <v-menu
              :value="infosMenu"
              @input="infosMenu = $event"
              :close-on-content-click="false"
              min-width="400px"
            >
              <template v-slot:activator="{ on }">
                <v-input
                  v-on="on"
                  prepend-icon="mdi-information-outline"
                  :error-messages="errors"
                >
                  <span style="cursor: pointer">{{ $t("Agency infos") }}</span>
                </v-input>
              </template>
              <v-card>
                <v-card-text>
                  <v-textarea
                    :label="$t('Infos')"
                    name="infos"
                    v-model="infos"
                  ></v-textarea>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    outlined
                    color="secondary"
                    @click="infosMenu = false"
                    >{{ $t("Close") }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-menu>
          </validation-provider>
        </v-col>
        <v-col lg="1" class="d-flex justify-center align-center">
          <v-btn :loading="loading" color="success" @click="save">{{
            $t("Save")
          }}</v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import snackbar from "@/mixins/snackbar";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "CustomizationToolbar",
  mixins: [snackbar],
  components: { ValidationObserver, ValidationProvider },
  data() {
    return {
      infosMenu: false,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      entities: (state) => state.entities.items,
    }),
    primaryColor: {
      get() {
        return this.$store.state.customizations.primaryColor;
      },
      set(value) {
        this.$store.commit("customizations/setPrimaryColor", value);
      },
    },
    entityId: {
      get() {
        return this.$store.state.customizations.entityId;
      },
      set(value) {
        this.$store.commit("customizations/setEntityId", value);
      },
    },
    editedItem: {
      get() {
        return this.$store.state.customizations.editedItem;
      },
      set(value) {
        this.$store.commit("customizations/setEditedItem", value);
      },
    },
    image: {
      get() {
        return this.$store.state.customizations.editedItem.image;
      },
      set(value) {
        this.$store.commit("customizations/setImage", value);
      },
    },
    infos: {
      get() {
        return this.$store.state.customizations.editedItem.infos;
      },
      set(value) {
        this.$store.commit("customizations/setInfos", value);
      },
    },
  },
  methods: {
    save() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.loading = true;
        this.$store
          .dispatch("customizations/saveEditedItem")
          .then(() => {
            this.loading = false;
            this.snackbar("success", this.$t("Customization saved"));
          })
          .catch((error) => {
            this.loading = false;
            if (error.response && error.response.status === 422) {
              let errors = error.response.data.errors;
              this.$refs.form.setErrors(errors);
            } else {
              this.snackbar("error", this.$t("Customization error"));
            }
          });
      });
    },
  },
  watch: {
    entityId() {
      this.$refs.form.reset();
    },
  },
};
</script>